import {
    isIntegrationConnection,
    INTEGRATION_CONNECTIONS_SETTINGS,
} from "../common/helpers/integrationConnection";
import { IntegrationConnection } from "../common/types/integrationConnection";
import { FinancialConnection } from "../common/types/financialConnection";
import { FinancialConnectionProviderLabel } from "../common/constants";

export function useConnectionProviderLabel(
    connection?: FinancialConnection | IntegrationConnection,
) {
    if (!connection) {
        return null;
    }

    return isIntegrationConnection(connection)
        ? INTEGRATION_CONNECTIONS_SETTINGS[connection.provider].label
        : FinancialConnectionProviderLabel[connection.connectionProvider];
}
